import {Component, Input, OnChanges} from '@angular/core';
import {FirebaseService} from '../app/firebase.service';
import {RechnungItems} from '../app/types';
import {User} from '../app/user';

@Component({
  selector: 'app-kunde-rechnung',
  templateUrl: './kunde-rechnung.component.html',
  styles: []
})
export class KundeRechnungComponent implements OnChanges {
  items: RechnungItems;
  @Input()
  user: User;
  @Input()
  admin: boolean;

  constructor(public service: FirebaseService) { }

  ngOnChanges() {
    if (!this.user) {
      this.items = null;
      return;
    }
    this.user.rechnung.subscribe(rechnung => {
      if (!rechnung) {
        this.items = null;
        return;
      }
      this.items = rechnung.buchungenMitKosten;
    });
  }
}
